import { createApiInstance } from "./apiClient";

const url = process.env.REACT_APP_WEB_API_URL;

export const getUserPageContent = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/pageContent/`, retry: true });

		const requestUrl = ``;

		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200) {
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				}
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (error) {
		console.error(error);
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getHomePageContent = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/pageContent/`, retry: true });

		const requestUrl = `home`;

		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (error) {
		console.error(error);
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};